import React from "react";
import { cn } from "@/lib/utils";

export const Bouncer = () => (
  <div className="flex min-h-screen items-center justify-center">
    <div className="flex items-center gap-2">
      <Ball />
      <Ball className="delay-160" />
      <Ball className="delay-320" />
    </div>
  </div>
);

const Ball = ({ className }: { className?: string }) => (
  <div
    className={cn(
      "ball relative size-4 animate-[bounce-animation_1.4s_ease-in-out_infinite] overflow-hidden rounded-full",
      className,
    )}
  ></div>
);
